<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { debounce } from '@/utils/tools'
export default {
  name: 'App',
  mounted() {
    // console.log("app mounted");
    // this.vhResize();
    window.addEventListener('resize', this.vhResize);
  },
  methods: {
    ...mapActions({
      actionSetVW: 'setVW',
    }),
    vhResize: debounce(async function(e){
      const width = window.innerWidth;
      this.actionSetVW(width);
    }, 200)
  }
}
</script>
<style>
/* 行楷 */
@font-face {
  font-family: 'xingkai';
  src: url('@/assets/font/xingkai.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
/* 苹方 */
@font-face {
  font-family: 'pingfang';
  src: url('@/assets/font/pingfang.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
/* 楷书 */
@font-face {
  font-family: 'simkai';
  src: url('@/assets/font/simkai.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
</style>
